import io from 'socket.io-client';
import gamesStore from 'stores/gamesStore';

class GameSockets {
  socket;

  constructor(namespace) {
    this.socket = io(`${process.env.REACT_APP_WEBSOCKET_URL}${namespace ? `/${namespace}` : ''}`);

    this.addListeners();
  }

  addListeners() {
    this.socket.on('connect', () => {
      console.log('Socket: Connected');
    });

    this.socket.on('disconnect', () => {
      console.log('Socket: Disconnect');
    });

    this.socket.on('pykGamesInfo', (data) => {
      console.log('pykGamesInfo', data);
      gamesStore.setGamesInfo(data);
    });

    // this.socket.on('gameInfoAdmin', (data) => {
    //   gamesStore.setGameInfo(data);
    // });

    this.socket.on('gameInfo', (data) => {
      gamesStore.setGameInfo(data);
    });

    this.socket.on('playerJoinedRoom', (data) => {
      console.log('playerJoinedRoom', data);
    });

    this.socket.on('chatMessage', (data) => {
      console.log('chatMessage', data);
    });

    this.socket.on('roomDiff', (data) => {
      console.log('roomDiff', data);
    });


    this.socket.connect();
  }

  joinIntoRoom(roomId) {
    this.socket.emit('adminJoinIntoRoom', { roomId });
  }

  closeSocket = () => {
    this.socket.removeAllListeners();
    this.socket.close();
  };
}

export default GameSockets;